module.exports = __webpack_public_path__ + "img/img-cfdee1.png";